"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDSKBeginsWithSubstringUsingLargestCellTokenLength = exports.getDSKBeginsWithSubstring = exports.getS2SubCellIds = exports.getIndexSubtrings = exports.s2Reducer = void 0;
/** @ignore Incorrectly eliminates sub cells in an collection of cell tokens */
const s2Reducer = (a, c, i, arr) => {
    const parentIdx = arr.findIndex((x) => c.includes(x) && x.length < c.length);
    if (parentIdx === -1) {
        if (!a.includes(c)) {
            a.push(c);
        }
    }
    return a;
};
exports.s2Reducer = s2Reducer;
/** for where strings are to be used as begins_with predicate values for dsk indexed geo objects, these substrings are not valid parent tokens! */
const getIndexSubtrings = (tokens, maxLength) => {
    const substrings = [];
    tokens.reduce((a, c) => {
        const substring = c.substring(0, maxLength);
        if (!a.includes(substring)) {
            a.push(substring);
        }
        return a;
    }, substrings);
    return substrings;
};
exports.getIndexSubtrings = getIndexSubtrings;
/** returns all sub cellsId of input s2CellId given child level. throws error is s2CellId level is greated than child level  */
const getS2SubCellIds = ({ s2CellId, childLevel }) => {
    const parentLevel = s2CellId.level();
    if (childLevel < parentLevel) {
        childLevel = parentLevel;
    }
    const firstChild = s2CellId.childBeginL(childLevel);
    const lastChild = s2CellId.childEndL(childLevel);
    const allChildren = [];
    for (let c = firstChild; !c.equals(lastChild); c = c.next()) {
        allChildren.push(c);
    }
    return allChildren;
};
exports.getS2SubCellIds = getS2SubCellIds;
const getDSKBeginsWithSubstring = ({ s2CellIds, childLevel, maxSubstringLength }) => {
    const levelNChidren = s2CellIds.map((s2CellId) => (0, exports.getS2SubCellIds)({ s2CellId, childLevel })).flat();
    const tokens = levelNChidren.map((c) => c.toToken());
    return (0, exports.getIndexSubtrings)(tokens, maxSubstringLength);
};
exports.getDSKBeginsWithSubstring = getDSKBeginsWithSubstring;
/**
 * wrapped for getDSKBeginsWithSubstring, using length of largest cell token as maxSubstringlength
 */
const getDSKBeginsWithSubstringUsingLargestCellTokenLength = ({ s2CellIds, childLevel, }) => {
    const lowestS3CellTokenLength = s2CellIds.reduce((a, s2CellId) => {
        const l = s2CellId.toToken().length;
        if (l < a) {
            a = l;
        }
        return a;
    }, 16);
    const maxSubstringLength = lowestS3CellTokenLength;
    return (0, exports.getDSKBeginsWithSubstring)({ s2CellIds, childLevel, maxSubstringLength });
};
exports.getDSKBeginsWithSubstringUsingLargestCellTokenLength = getDSKBeginsWithSubstringUsingLargestCellTokenLength;
